import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

const TableActionButton = styled(Button)(() => ({
  backgroundColor: '#3F3F3F',
  borderColor: '#2E3236',
  color: '#fff',
  textTransform: 'none',
  minHeight: 32,
  height: 32,
  paddingTop: 0,
  paddingBottom: 0,
  lineHeight: 1,
}));

export default TableActionButton;
